<section class="jobs-section">
  <div class="jobs-container">
    <!-- Navbar -->
    <nav class="flex items-center justify-between mb-4 md:mb-6 pb-3 md:pb-4 border-b border-slate-200">
      <div class="flex items-center gap-4">
        <a routerLink="/" class="flex items-center">
          <img src="assets/images/BeExpert-logo (2).svg" alt="BeExpert" class="h-7 md:h-9 object-contain"
            onerror="this.onerror=null; this.src='assets/images/logo04.png'" />
        </a>
      </div>
      <div class="flex items-center gap-3">
        <button routerLink="/"
          class="text-sm font-medium text-slate-600 hover:text-indigo-600 transition hidden md:block">Home</button>
        <button routerLink="/login"
          class="px-4 py-2 md:px-5 md:py-2.5 text-[13px] md:text-sm font-semibold text-white bg-indigo-600 hover:bg-indigo-700 rounded-xl shadow-sm transition-all ml-1 md:ml-2">Login
          to Apply</button>
      </div>
    </nav>
    <!-- Header & Search -->
    <div
      class="mb-4 md:mb-6 bg-white p-3.5 md:p-5 rounded-2xl md:rounded-[1.5rem] shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)] border border-slate-100 relative overflow-hidden">
      <!-- Decorative background -->
      <div
        class="absolute top-0 right-0 -mr-16 -mt-16 w-48 h-48 rounded-full bg-indigo-50 blur-3xl opacity-60 pointer-events-none">
      </div>

      <div class="relative z-10">
        <div class="flex flex-wrap items-center gap-4 mb-1">
          <button routerLink="/" class="inline-flex items-center gap-1.5 px-3.5 py-1.5 text-sm font-semibold text-slate-600 bg-white border border-slate-200 rounded-xl shadow-sm hover:bg-slate-50 hover:text-indigo-600 hover:border-indigo-200 transition-all">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="m12 19-7-7 7-7"></path>
              <path d="M19 12H5"></path>
            </svg>
            Back
          </button>
          <h2 class="text-xl md:text-3xl font-black text-slate-900 tracking-tight">
            All Job <span class="brand-gradient-text">Openings</span>
          </h2>
        </div>
        <p class="text-slate-500 text-sm md:text-base font-medium max-w-2xl mb-3">
          Browse every live role and apply in one click. Filter by role, location, or work mode.
        </p>

        <!-- Search Bar Container -->
        <div class="flex flex-col md:flex-row gap-3 bg-slate-50/80 p-1.5 rounded-xl border border-slate-200 backdrop-blur-sm">
          <!-- Keyword -->
          <div class="relative flex-1">
            <svg class="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" fill="none"
              stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
            <input type="text" placeholder="Search role, company or keyword"
              class="w-full h-11 md:h-10 pl-10 pr-4 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-400 focus:ring-2 focus:ring-indigo-100 transition-all"
              (input)="onSearch($event)">
          </div>

          <div class="flex gap-3 w-full md:w-auto">
            <!-- Location -->
            <div class="relative flex-1 md:max-w-[200px] lg:max-w-[240px]">
              <svg class="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" fill="none"
                stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.242-4.243a8 8 0 1111.314 0z"></path>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
              </svg>
              <input type="text" placeholder="Location"
                class="w-full h-11 md:h-10 pl-10 pr-4 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-400 focus:ring-2 focus:ring-indigo-100 transition-all"
                (input)="onLocationSearch($event)">
            </div>

            <!-- Job Type -->
            <div class="relative flex-1 md:max-w-[160px] lg:max-w-[200px]">
              <select
                class="w-full h-11 md:h-10 px-4 bg-white border border-slate-200 rounded-lg text-sm text-slate-700 focus:outline-none focus:border-indigo-400 focus:ring-2 focus:ring-indigo-100 transition-all appearance-none cursor-pointer"
                (change)="onJobTypeChange($event)">
                <option value="">All Job Types</option>
                <option value="Full-Time">Full Time</option>
                <option value="Internship/Training">Internship</option>
                <option value="Part-Time">Part Time</option>
                <option value="Contract">Contract</option>
              </select>
              <svg class="absolute right-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-slate-400 pointer-events-none"
                fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            </div>
          </div>
        </div>

        <!-- Work Mode Pills -->
        <div class="flex overflow-x-auto hide-scrollbar items-center gap-2 mt-3 pb-1 -mx-4 px-4 md:mx-0 md:px-0 md:flex-wrap md:overflow-visible">
          <button class="px-3 py-1 rounded-full text-[11px] font-semibold transition-all border"
            [ngClass]="selectedWorkMode === '' ? 'bg-indigo-600 text-white border-indigo-600' : 'bg-slate-50 text-slate-600 border-slate-200 hover:border-slate-300 hover:bg-slate-100'"
            (click)="onWorkModeChange('')">All Modes</button>
          <button class="px-3 py-1 rounded-full text-[11px] font-semibold transition-all border"
            [ngClass]="selectedWorkMode === 'Remote' ? 'bg-indigo-600 text-white border-indigo-600' : 'bg-slate-50 text-slate-600 border-slate-200 hover:border-slate-300 hover:bg-slate-100'"
            (click)="onWorkModeChange('Remote')">Remote</button>
          <button class="px-3 py-1 rounded-full text-[11px] font-semibold transition-all border"
            [ngClass]="selectedWorkMode === 'Hybrid' ? 'bg-indigo-600 text-white border-indigo-600' : 'bg-slate-50 text-slate-600 border-slate-200 hover:border-slate-300 hover:bg-slate-100'"
            (click)="onWorkModeChange('Hybrid')">Hybrid</button>
          <button class="px-3 py-1 rounded-full text-[11px] font-semibold transition-all border"
            [ngClass]="selectedWorkMode === 'Onsite' ? 'bg-indigo-600 text-white border-indigo-600' : 'bg-slate-50 text-slate-600 border-slate-200 hover:border-slate-300 hover:bg-slate-100'"
            (click)="onWorkModeChange('Onsite')">Onsite</button>
        </div>
      </div>
    </div>
    <div class="jobs-grid">
      <ng-container *ngIf="isLoading">
        <div class="job-card" *ngFor="let i of [1,2,3,4,5,6]">
          <div class="animate-pulse flex space-x-4">
            <div class="rounded-xl bg-slate-100 h-14 w-14 border border-slate-200"></div>
            <div class="flex-1 space-y-4 py-2 mt-1">
              <div class="h-3.5 bg-slate-200 rounded w-3/4"></div>
              <div class="space-y-3">
                <div class="h-3 bg-slate-100 rounded w-1/2"></div>
                <div class="h-3 bg-slate-50 rounded w-5/6"></div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!isLoading && jobs.length === 0">
        <div
          class="col-span-full flex flex-col justify-center items-center py-20 px-4 text-center bg-white rounded-3xl border border-slate-100 shadow-sm mt-4 w-full">
          <div class="w-20 h-20 bg-slate-50 rounded-2xl flex items-center justify-center mb-5 border border-slate-100">
            <svg class="w-10 h-10 text-slate-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
          </div>
          <h3 class="text-xl font-bold text-slate-900 mb-2">No jobs match your criteria</h3>
          <p class="text-slate-500 max-w-md mx-auto">Try adjusting your search keywords, location, or work mode to find
            what you're looking for.</p>
          <button
            class="mt-6 px-6 py-2.5 bg-indigo-50 text-indigo-700 font-semibold rounded-xl hover:bg-indigo-100 transition-colors"
            (click)="searchQuery=''; locationQuery=''; selectedJobType=''; selectedWorkMode=''; fetchJobs(true)">Clear
            All Filters</button>
        </div>
      </ng-container>

      <ng-container *ngIf="jobs.length > 0">
        <div *ngFor="let job of jobs; trackBy: trackByJobId" class="job-card">
          <div class="flex items-start justify-between">
            <div class="flex items-center gap-3">
              <div class="job-logo-box">
                <img [alt]="job.company_name" class="object-contain" loading="lazy"
                  [src]="job.company_logo || 'https://ui-avatars.com/api/?name=' + job.company_name" />
              </div>
              <div>
                <h3 class="job-title">{{ job.job_title }}</h3>
                <p class="job-company">{{ job.company_name }}</p>
              </div>
            </div>
            <div class="flex items-center gap-1 relative">
              <button class="btn-icon" (click)="shareJob(job, $event)">
                <svg aria-hidden="true" class="lucide lucide-share2 w-4 h-4" fill="none" stroke="currentColor"
                  stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="5" r="3"></circle>
                  <circle cx="6" cy="12" r="3"></circle>
                  <circle cx="18" cy="19" r="3"></circle>
                  <line x1="8.59" x2="15.42" y1="13.51" y2="17.49"></line>
                  <line x1="15.41" x2="8.59" y1="6.51" y2="10.49"></line>
                </svg>
              </button>
              <button class="btn-icon" (click)="saveJob(job, $event)">
                <svg aria-hidden="true" class="lucide lucide-bookmark w-4 h-4"
                  [attr.fill]="job.is_saved ? 'currentColor' : 'none'" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"></path>
                </svg>
              </button>

              <!-- Custom Share Dropdown Fallback -->
              <div *ngIf="activeShareDropdown === job.job_id"
                class="absolute right-0 top-10 bg-white rounded-lg shadow-xl border border-slate-100 p-2 z-50 flex flex-col gap-1 w-48">
                <button
                  class="flex items-center gap-2 px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 rounded-md transition w-full text-left"
                  (click)="shareTo('whatsapp', job, $event)">
                  <svg class="w-4 h-4 text-emerald-500" viewBox="0 0 24 24" fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z">
                    </path>
                  </svg> WhatsApp
                </button>
                <button
                  class="flex items-center gap-2 px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 rounded-md transition w-full text-left"
                  (click)="shareTo('linkedin', job, $event)">
                  <svg class="w-4 h-4 text-blue-600" viewBox="0 0 24 24" fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z">
                    </path>
                  </svg> LinkedIn
                </button>
                <button
                  class="flex items-center gap-2 px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 rounded-md transition w-full text-left"
                  (click)="shareTo('twitter', job, $event)">
                  <svg class="w-4 h-4" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z">
                    </path>
                  </svg> X (Twitter)
                </button>
                <button
                  class="flex items-center gap-2 px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 rounded-md transition w-full text-left"
                  (click)="shareTo('facebook', job, $event)">
                  <svg class="w-4 h-4 text-blue-700" viewBox="0 0 24 24" fill="currentColor">
                    <path
                      d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.469h3.047V7.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.469h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z">
                    </path>
                  </svg> Facebook
                </button>
                <button
                  class="flex items-center gap-2 px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 rounded-md transition w-full text-left"
                  (click)="shareTo('telegram', job, $event)">
                  <svg class="w-4 h-4 text-sky-500" viewBox="0 0 24 24" fill="currentColor">
                    <path
                      d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm5.894-15.897L15.343 19.2c-.2.909-.74.114-1.25-.262l-3.473-2.55-1.68 1.616c-.18.173-.34.333-.7.333l.254-3.524 6.425-5.787c.28-.248-.061-.387-.435-.138L6.5 13.91l-3.418-1.071c-.742-.232-.756-.742.155-1.1L16.922 6.64c.633-.232 1.183.136.972 1.463z">
                    </path>
                  </svg> Telegram
                </button>
                <button
                  class="flex items-center gap-2 px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 rounded-md transition w-full text-left"
                  (click)="shareTo('email', job, $event)">
                  <svg class="w-4 h-4 text-gray-500" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="2" y="4" width="20" height="16" rx="2" ry="2"></rect>
                    <path d="M2 4l10 8 10-8"></path>
                  </svg> Email
                </button>
                <hr class="my-1 border-slate-100">
                <button [id]="'copy-btn-' + job.job_id"
                  class="flex items-center gap-2 px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 rounded-md transition w-full text-left"
                  (click)="copyLink(job, $event)">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect>
                    <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path>
                  </svg> Copy Link
                </button>
              </div>
            </div>
          </div>
          <div class="job-badges">
            <span class="badge-default">
              <svg aria-hidden="true" class="lucide lucide-briefcase w-3.5 h-3.5 text-indigo-400" fill="none"
                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                <rect height="14" rx="2" width="20" x="2" y="6"></rect>
              </svg>
              {{ job.experience_level || 'Fresher' }}
            </span>
            <span class="badge-primary">
              <svg aria-hidden="true" class="lucide lucide-laptop w-3.5 h-3.5" fill="none" stroke="currentColor"
                stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18 5a2 2 0 0 1 2 2v8.526a2 2 0 0 0 .212.897l1.068 2.127a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45l1.068-2.127A2 2 0 0 0 4 15.526V7a2 2 0 0 1 2-2z">
                </path>
                <path d="M20.054 15.987H3.946"></path>
              </svg>
              {{ job.work_mode }}
            </span>
          </div>
          <p class="job-location">
            <svg aria-hidden="true" class="lucide lucide-map-pin w-3.5 h-3.5 text-indigo-400" fill="none"
              stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0">
              </path>
              <circle cx="12" cy="10" r="3"></circle>
            </svg>
            {{ job.locations?.length ? job.locations.join(', ') : 'Not specified' }}
          </p>
          <div class="job-footer">
            <span class="job-meta">
              <span>{{ getTimeAgo(job.published_at || job.created_at) }}</span> &middot; <span>{{ job.number_of_openings
                || 1 }}</span> opening<span *ngIf="job.number_of_openings !== 1">s</span>
            </span>
            <button class="btn-apply group/btn" (click)="navigateToJob(job.job_id)">
              Apply Now
              <svg aria-hidden="true" class="lucide lucide-arrow-up-right w-4 h-4" fill="none" stroke="currentColor"
                stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M7 7h10v10"></path>
                <path d="M7 17 17 7"></path>
              </svg>
            </button>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Pagination 'Load More' Section -->
    <div class="flex justify-center mt-12 mb-8" *ngIf="jobs.length > 0 && hasMore">
      <button
        class="px-6 py-3 text-sm font-semibold text-white bg-indigo-600 hover:bg-indigo-700 rounded-xl shadow-sm transition-all flex items-center justify-center disabled:opacity-70 disabled:bg-slate-400 disabled:cursor-not-allowed group"
        (click)="loadMore()" [disabled]="isLoadingMore">
        <ng-container *ngIf="!isLoadingMore">
          Load More Jobs
          <svg class="w-4 h-4 ml-2 transition-transform group-hover:translate-y-0.5" fill="none" stroke="currentColor"
            viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
          </svg>
        </ng-container>
        <ng-container *ngIf="isLoadingMore">
          <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
          Loading...
        </ng-container>
      </button>
    </div>

  </div>
</section>